<template>
  <div class="collapsible-card" 
    :class="classObj" 
    @click="() => bodyCollapsed = !bodyCollapsed" 
    @keyup.enter="() => bodyCollapsed = !bodyCollapsed" 
    tabindex="0"
    :aria-expanded="!bodyCollapsed"
    role="button">
    <div class="collapsible-card-body">
      <div class="collapsible-card-header">
        <slot name="header">HEADER</slot>
      </div>
      <div class="collapsible-card-spacer"></div>

      <div class="collapsible-card-icon-container">
        <i class="fas fa-angle-down" :class="iconTransisition"></i>
      </div>

      <transition name="collapsible-card-fade" mode="in-out">
        <div v-show="!bodyCollapsed" class="collapsible-card-body-text">
          <slot name="body">BODY</slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "CollapsibleCard",
  props: {
    isTabbed: {
      type: Boolean,
      default: false,
      notes:
        "a bool to determine if the guide is within a tabbed document or freestanding, adds a class that overides standard media queries"
    }
  },
  data: () => {
    return {
      bodyCollapsed: true
    };
  },
  computed: {
    iconTransisition() {
      if (!this.bodyCollapsed) {
        return "icon-rotate icon-rotate-down";
      } else if (this.bodyCollapsed) {
        return "icon-rotate";
      }
    },
    classObj() {
      let klass = {};
      this.isTabbed
        ? (klass["collapsible-card-tabbed"] = true)
        : (klass["collapsible-card-untabbed"] = true);

      return klass;
    }
  }
};
</script>

